import { DtoWhItemList } from './../dominio/DtoWhItemList';
import { WhItemMastServicio } from './../servicio/WhItemMast.service';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { MaMiscelaneosdetalleServicio } from './../../../core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { SelectItem, LazyLoadEvent } from 'primeng/primeng';
import { MessageService } from 'primeng/api';
import { FiltroWhItemMast } from './../dominio/FiltroWhItemMast';
import { Component, OnInit, ChangeDetectorRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NoAuthorizationInterceptor } from '../../../../util/interceptor/NoAuthorizationInterceptor';
import { CoDocumento } from 'src/app/erp/comercial/codocumento/dominio/CoDocumento';
import { CoCotizacion } from 'src/app/erp/comercial/cotizacion/dominio/CoCotizacion';
import { WhItemDetalleNuevoComponent } from './whitemmast-detalle-nuevo.component';
import { WhItemInventarioComponent } from './whitemmast-inventario.component';
import { Table } from 'primeng/table';
import { DtoWhItemmast } from '../dominio/DtoWhItemmast';

@Component({
    selector: 'app-item-nuevo-listado',
    templateUrl: './whItemmast-listado-nuevo.component.html'
})
export class WhItemNuevoMastComponent extends PrincipalBaseComponent implements OnInit {
    origen: string = '';
    tag: string = '';
    acction: string;
    subscribedParam = 'initial value';
    filtro: FiltroWhItemMast = new FiltroWhItemMast();
    seleccionados: DtoWhItemList;
    cargando: Boolean = true;
    lstEstados: SelectItem[] = [];
    lstDescripcion: SelectItem[] = [];
    codigo: string;
    desc: string;
    verdescuentos: string;
    coCotizacion: CoCotizacion = new CoCotizacion();
    coDocumento: CoDocumento = new CoDocumento();
    CoCotizacion = new CoCotizacion();
    verModal: Boolean = false;
    listaAlmacences: DtoWhItemmast[] = [];

    constructor(
        private readonly route: ActivatedRoute,
        private router: Router,
        private maMiscelaneosdetalleServicio: MaMiscelaneosdetalleServicio,
        private cdref: ChangeDetectorRef,
        private whItemMastServicio: WhItemMastServicio,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }
    paginacion: any = new Object();
    @ViewChild(Table,{static:false}) dt: Table;
    @ViewChild(WhItemDetalleNuevoComponent,{static:false}) whItemDetalleNuevoComponent: WhItemDetalleNuevoComponent;
    @ViewChild(WhItemInventarioComponent,{static:false}) whItemInventarioComponent: WhItemInventarioComponent;

    @Output() alCerrarCabecera = new EventEmitter();

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    alCerrar(bean: any) {
        //this.verModal = false;
        if ( this.origen === 'PEDIDO') {
            this.coDocumento = bean;
        } else if (this.origen === 'COTIZACION') {
            this.coCotizacion = bean;
        }
        this.alCerrarCabecera.emit(bean);
    }

    ngOnInit(): void {
        this.lstDescripcion.push({ label: 'Item', value: 'IT' });
        this.lstDescripcion.push({ label: 'Código Interno', value: 'IN' });
        this.lstDescripcion.push({ label: 'Descripción', value: 'DE' });
    }

    iniciarModal(origen: string, almacen: string, acction: string, verdescuentos: string, bean: any) {
        this.verModal = true;
        this.seleccionados = null;
        this.acction = acction;
        this.verdescuentos = verdescuentos;
        this.origen = origen;

        const ss = sessionStorage.getItem('filtrosItem');
        if (ss !== undefined && ss !== null && ss !== 'LIMPIAR') {
            const prefiltro = JSON.parse(ss) as FiltroWhItemMast;
            this.filtro = prefiltro;
            this.filtro.almacen = almacen;
            this.buscar();
        } else {

            this.filtro = new FiltroWhItemMast();
            this.filtro.criterio = 'DE';
            this.filtro.almacen = almacen;
        }

        if (origen === 'PEDIDO') {
            this.coDocumento = bean;
        } else if (this.origen === 'COTIZACION') {
            this.coCotizacion = bean;
        }
        this.cargarEstados();
    }

    onRowDblclick(event) {
        if (this.origen === 'PEDIDO') {
            this.agregarItemCotizacion();
        } else {
            this.agregarItemSeleccionados();
        }
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    cargarEstados() {
        this.bloquearPagina();
        this.lstEstados = [];
        this.lstEstados.push({ label: ' -- Ver Todos -- ', value: null });
        this.maMiscelaneosdetalleServicio.listarPorCabecera('CO', '999999', 'ESTSTOCK').then(
            res => {
                res.forEach(
                    reg => {
                        this.lstEstados.push({ label: reg.descripcionlocal, value: reg.pk.codigoelemento.trim() });
                    }
                );
                this.cargando = false;
                this.desbloquearPagina();
                this.filtro.estado = 'ST';
            }
        );
    }

    cargarPaginacion(event: LazyLoadEvent) {
        if (this.cargando) {
            return;
        }

        this.bloquearPagina();

        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;

        sessionStorage.setItem('filtrosItem', JSON.stringify(this.filtro));
        this.whItemMastServicio.listarItemPaginacion(this.filtro)
            .then(res => {
                this.filtro.paginacion = res;
                this.desbloquearPagina();
            });
    }

    buscar() {
        this.cargando = false;
        this.dt.reset();
        this.listaAlmacences = [];
        this.seleccionados = null;
    }

    agregarItemSeleccionadosFila(seleccionados: DtoWhItemList) {
        if (seleccionados === undefined || seleccionados === null) {
            this.mostrarMensajeAdvertencia('Seleccionar un Item');
            return;
        }
        this.seleccionados = seleccionados;

        if (this.origen === 'PEDIDO') {
            this.whItemDetalleNuevoComponent.iniciarModal(this.acction, this.origen, 'N', this.coDocumento, this.seleccionados);
        } else {
            this.whItemDetalleNuevoComponent.iniciarModal(this.acction, this.origen, 'N', this.coCotizacion, this.seleccionados);
        }
    }

    agregarItemSeleccionados() {
        if (this.seleccionados === undefined || this.seleccionados === null) {
            this.mostrarMensajeAdvertencia('Seleccionar un Item');
            return;
        }
        if (this.origen === 'PEDIDO') {
            this.whItemDetalleNuevoComponent.iniciarModal(this.acction, this.origen, 'N', this.coDocumento, this.seleccionados);
        } else {
            this.whItemDetalleNuevoComponent.iniciarModal(this.acction, this.origen, 'N', this.coCotizacion, this.seleccionados);
        }
    }

    onDoblRowSelect(event: any) {
        this.codigo = '';
        const reg: any = new Object();
        reg.data = event.data;
        reg.tag = this.tag;
        this.mostrarMensajeExito(reg.data.item);
        this.codigo = reg.data.item;
        this.desc = reg.data.descripcionLocal;
        this.mostrarMensajeExito(reg.data.item);
    }

    onRowSelect(event) {
        console.log('onRowSelect' + this.seleccionados.condicion);
        const filtro = new FiltroWhItemMast();
        filtro.item = this.seleccionados.item;
        filtro.condicion = this.seleccionados.condicion;
        filtro.almacen= this.filtro.almacen;
        filtro.estado= this.filtro.estado;

        this.listaAlmacences = [];

        this.whItemMastServicio.listarItemPaginacionAlmacenes(filtro).then(
            x => {
                this.listaAlmacences = x;
            }
        );
    }

    verPedidoActual() {
        this.router.navigate(['royal/pedido-mantenimiento', 'VERITEMS', JSON.stringify(this.coDocumento), this.acction], { skipLocationChange: true });
    }

    verInventario() {
        if (this.seleccionados === null || this.seleccionados === undefined) {
            this.mostrarMensajeAdvertencia('Debe seleccionar un Item');
            return;
        }
        this.whItemInventarioComponent.iniciarModal(this.seleccionados.item.trim(), this.seleccionados.descripcionLocal.trim(), this.filtro.almacen.trim());
    }
    agregarItemCotizacion() {
        this.agregarItemSeleccionados();
    }
    verCotizacionActual() {
        console.log(this.coCotizacion);
        this.router.navigate(['/royal/cocotizacion-mantenimiento', 'VERITEMS', JSON.stringify(this.coCotizacion), this.acction], { skipLocationChange: true });
    }
}
